<template>
	<r-standard-modal-form @closeModal="$emit('closeModal')">
		<span slot="title"> Clear Workbook? </span>
		<div slot="body" class="clear-table-modal-body">
			<div class="alt-line">
				Would you like the clear all data from this workbook? All tasks will be removed.  This can’t be undone.
			</div>
			<r-button theme="warn" fullWidth class="clear-button" @click="clearData">
				Clear Workbook
			</r-button>
			<div class="cancel-button">
				<span class="cancel-button-text" @click="$emit('closeModal')">Cancel</span>
			</div>
		</div>
	</r-standard-modal-form>
</template>

<script>

export default {
	name:'clear-table-modal',
	props:{
		sheetView:{
			required: true,
			type: Object,
		},
	},
	computed:{
		dataStore(){
			return this.sheetView.sheetViewGroup.dataStore;
		},
	},
	methods:{
		closeForm(){
			this.$emit('closeModal');
		},		
		clearData(){
			this.closeForm();
			this.dataStore.deleteAllRecords();
		},
	}
}

</script>

<style scoped lang="scss">

.clear-table-modal-body{

	width: 100%;

	.alt-line{
		font-family: $rvFontFamily;
		font-size: 14px;
		line-height: 21px;
		letter-spacing: 0.01em;
		color: #595962;
		margin-bottom: 30px;

		.alt-button-text{
			font-family: $rvFontFamily;
			font-weight: 500;
			font-size: 14px;
			line-height: 21px;
			letter-spacing: 0.01em;
			color: $p-color-blue-300;
			@include clickable;
		}
	}

	.clear-button{
		width: 100%;
		margin-bottom: 24px;
	}

	.cancel-button{
		@include flex(row, center, center);

		.cancel-button-text{
			font-family: $rvFontFamily;
			font-weight: 500;
			font-size: 14px;
			line-height: 21px;
			text-align: center;
			letter-spacing: 0.01em;
			color: $p-color-grey-500;

			@include clickable;
		}
	}
}
</style>
